import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

interface AnimatedBarProps {
  /** 0–100 (já calculado). */
  pct: number;
  cor: string;
  h?: string;
  /** Atraso pra fazer stagger em listas (ex.: index * 0.05). */
  delay?: number;
  trackBg?: string;
}

/** Barra que cresce de 0 → pct no mount (e re-anima quando pct muda). */
export const AnimatedBar = ({
  pct,
  cor,
  h = '6px',
  delay = 0,
  trackBg = 'rgba(15,23,42,0.05)',
}: AnimatedBarProps) => (
  <Box bg={trackBg} borderRadius="full" h={h} overflow="hidden">
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: `${Math.max(0, Math.min(100, pct))}%` }}
      transition={{ duration: 0.6, ease: 'easeOut', delay }}
      style={{ height: '100%', background: cor, borderRadius: '999px' }}
    />
  </Box>
);
